import dayjs from "dayjs";

const strict = true;

const state = {
  sessionDuration: parseInt(
    process.env.VUE_APP_FONDOEST_USER_SESSION_MINUTES_DURATION
  ),
  actionMoment: null,
  newActionMoment: null
};

const getters = {
  sessionDuration: state => state.sessionDuration,
  actionMoment: state => state.actionMoment,
  newActionMoment: state => state.newActionMoment
};

const mutations = {
  RESET(state) {
    state.sessionDuration = parseInt(
      process.env.VUE_APP_FONDOEST_USER_SESSION_MINUTES_DURATION
    );
    state.actionMoment = null;
    state.newActionMoment = null;
  },
  actionMoment(state) {
    state.actionMoment = dayjs().toISOString();
  },
  newActionMoment(state) {
    state.newActionMoment = dayjs().toISOString();
  },
  resetActionMoment(state) {
    state.actionMoment = state.newActionMoment;
  }
};

const actions = {};

export default {
  namespaced: true,
  strict,
  state,
  getters,
  mutations,
  actions
};
